export default {
  id: 'teams_promote_jobs',
  title: 'Promote jobs',
  type: 'Direct',
  relations: [ 'MANY_JOBS' ],
  description: 'Send up to 4 selected jobs to your employees so they can easily share them across their network.',
  body: `<div>
    <p>[[INPUT_INTRODUCTION_TEXT]]</p>
    <hr>
    <BLOCK_JOB>
    <hr>
    <p>[[INPUT_END_TEXT]]</p>
  </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  blocks: {
    BLOCK_JOB: `
      <h2 style="margin: 0px"><strong style='font-weight: bold; font-size: 16px'>{{JOB_[ID]_TITLE}}</strong></h2>
      <div style='display: inline-block; margin: 0px'>
        <a style='display: inline-block; color:#333' href='{{JOB_[ID]_LINKEDIN_SHARE_LINK}}'>
          <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>LinkedIn</pre>
        </a>
        <a style='display: inline-block; color:#333' href='{{JOB_[ID]_FACEBOOK_SHARE_LINK}}'>
          <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Facebook</pre>
        </a>
        <a style='display: inline-block; color:#333' href='{{JOB_[ID]_WHATSAPP_SHARE_LINK}}'>
          <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>WhatsApp</pre>
        </a>
        <a style='display: inline-block; color:#333' href='{{JOB_[ID]_TWITTER_SHARE_LINK}}'>
          <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Twitter</pre>
        </a>
        <a style='display: inline-block; color:#333' href='{{JOB_[ID]_MESSENGER_SHARE_LINK}}'>
          <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Messenger</pre>
        </a>
      </div>
      <div>
        <p>Checkout possible matches among your LinkedIn connections.</p>
        <a style='display: inline-block; color:#333' href='{{JOB_[ID]_MATCH_LINK}}'>
          <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>LinkedIn Matches</pre>
        </a>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following jobs with your network to win rewards! ...',
      defaultValue: 'Share the following jobs with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text at the end',
      placeholder: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}...',
      defaultValue: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteJobs.js